module.exports = __webpack_public_path__ + "static/img/83.5ed84fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/83.png
// module id = wfmB
// module chunks = 1